import { splitSuggestions } from '@/functions/documentSuggestions.ts'

/** Extracts the first suggestion from a preference text block, or null if none found. */
export function extractDefaultFromPreference(preferenceText) {
  if (!preferenceText) return null
  const suggestions = splitSuggestions(preferenceText)
  return suggestions.length ? suggestions[0].text : null
}

export function getNewPatientInfo(appUserMedication) {
  if (!appUserMedication?.autoUseFirstPatientInfo) return null;
  const preferenceText = appUserMedication.patientInfos;
  return extractDefaultFromPreference(preferenceText);
}

export function getNewPharmacyInfo(appUserMedication) {
  if (!appUserMedication?.autoUseFirstPharmacyInfo) return null;
  const preferenceText = appUserMedication.pharmacyInfos;
  return extractDefaultFromPreference(preferenceText);
}

/**
 * Finds the matching AppUserMedication preference for a given medication,
 * first by originalText, then by sctSubstanceKey as fallback.
 */
export function findMedicationPreference(suggestions, originalText, sctSubstanceKey = null) {
  return suggestions.find(item => item.originalText === originalText)
    ?? (sctSubstanceKey ? suggestions.find(item => item.sctSubstanceKey === sctSubstanceKey) : null)
    ?? null
}